module.exports = __webpack_public_path__ + "img/evisa-icon3.f7b506e6.png";